import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingBarModule } from '@ngx-loading-bar/core';

import { NgxMaskModule } from 'ngx-mask';

import { SharedModule } from '../../shared/shared.module';

import { NgxCurrencyModule } from "ngx-currency";
export const currencyMask = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true
};

import {
  ServiceProvidersComponent,
  ServiceProvidersListComponent,
  ServiceProvidersNewComponent,
  ServiceProvidersEditComponent
} from './';

@NgModule({
  declarations: [
    ServiceProvidersComponent,
    ServiceProvidersListComponent,
    ServiceProvidersNewComponent,
    ServiceProvidersEditComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingBarModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCurrencyModule.forRoot(currencyMask),
    NgxMaskModule.forRoot()
  ]
})
export class ServiceProvidersModule { }
